export default (axios) => ({
    create: (data) => axios.post('u/tickets?origin=benhvien16a.com', data).then((_) => _.data),
});
